<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-col cols="12">
      <v-alert v-if="errors" prominent type="error" color="red" dense>{{
          errors
        }}</v-alert>
      <v-alert v-if="success" prominent type="success" color="green" dense>{{
          success
        }}</v-alert>
    </v-col>
    <v-card class="mb-2">
      <v-card-text class="py-2">
        <v-row dense align="center">
          <v-col cols="12" md="5">
            <div class="text-h6">Invoice Report</div>
            <div class="report-meta">
              Date: <strong>{{ date }}</strong>
              <span class="mx-2">|</span>
              User: <strong>{{ selectedUserName }}</strong>
              <span class="mx-2">|</span>
              Printed by: <strong>{{ printedByName }}</strong>
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-autocomplete
              :items="users"
              item-text="full_name"
              item-value="id"
              item-key="id"
              label="Select User"
              v-on:change="getReports()"
              v-model="searchParam.user_id"
              :loading="isLoading"
              outlined
              dense
              hide-details
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Select Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                @input="menu2 = false"
                @click:date="dateSelect"
                :max="nowDate"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="1">
            <v-btn depressed color="primary" append-icon="mdi-printer" v-on:click="printList" block>
              Print
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card id="print">
      <strong>Summary</strong>
      <template>
        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">Title</th>
              <th class="text-left">Amount</th>
              <th class="text-left">Qty</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td colspan="3"><strong>Collection</strong></td>
            </tr>
            <tr>
              <td>Consultation</td>
              <td v-if="desserts">{{ desserts.consultation_ledger_total }}</td>
              <td v-if="consultancy_desserts">{{ consultancy_desserts.length }}</td>
            </tr>
            <tr>
              <td>Investigation</td>
              <td v-if="desserts">{{ desserts.investigation_ledger_total }}</td>
              <td v-if="investigation_desserts">{{ investigation_desserts.length }}</td>
            </tr>
            <tr>
              <td>Laser</td>
              <td v-if="desserts">{{ desserts.laser_ledger_total }}</td>
              <td v-if="laser_desserts">{{ laser_desserts.length }}</td>
            </tr>
            <tr>
              <td>Injection</td>
              <td v-if="desserts">{{ desserts.injection_ledger_total }}</td>
              <td v-if="injection_desserts">{{ injection_desserts.length }}</td>
            </tr>
            <tr>
              <td>Operation</td>
              <td v-if="desserts">{{ desserts.operation_ledger_total }}</td>
              <td v-if="operation_desserts">{{ operation_desserts.length }}</td>
            </tr>
            <tr>
              <td>Due Collection</td>
              <td v-if="desserts">{{ desserts.duecollect_ledger_total }}</td>
              <td v-if="due_desserts">{{ due_desserts.length }}</td>
            </tr>
            <tr>
              <th class="text-right">Total Collection</th>
              <th v-if="desserts">{{ desserts.total_invoice_received }}</th>
              <td></td>
            </tr>
            <tr>
              <td colspan="3"><strong>Settlement / Deduction</strong></td>
            </tr>
            <tr>
              <td>Void/Cancel</td>
              <td v-if="desserts">{{ desserts.void_inv_ledger_total }}</td>
              <td v-if="void_desserts">{{ void_desserts.length }}</td>
            </tr>
            <tr>
              <td>Refund To Patient</td>
              <td v-if="desserts">{{ desserts.refund_inv_ledger_total }}</td>
              <td v-if="refund_desserts">{{ refund_desserts.length }}</td>
            </tr>
            <tr>
              <td>Doctor Payment</td>
              <td v-if="desserts">{{ desserts.doctor_pay_ledger_total }}</td>
              <td v-if="doctor_paid_desserts">{{ doctor_paid_desserts.length }}</td>
            </tr>
            <tr>
              <td>Cashback</td>
              <td v-if="desserts">{{ desserts.total_cashback }}</td>
              <td></td>
            </tr>
            <tr>
              <th class="text-right">Total Settlement</th>
              <th v-if="desserts">{{ desserts.total_settlement }}</th>
              <td></td>
            </tr>
            <tr>
              <th class="text-right">Total Balance</th>
              <th v-if="desserts">{{ desserts.total_balance }}</th>
              <td></td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>
      <br />
      <strong>Payment Method Received</strong>
      <v-data-table
          :headers="received_payment_method_header"
          :items="received_payment_method_desserts"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          :hide-default-footer="true"
          disable-pagination
      >
        <template v-slot:item.slno="{ item }">
          {{ received_payment_method_desserts.indexOf(item) + 1 }}
        </template>
        <template slot="body.append">
          <tr>
            <td></td>
            <th>Total Received Amount:</th>
            <th v-if="desserts">
              {{ desserts.total_payment_method }}
            </th>
          </tr>
        </template>
      </v-data-table>
      <br />
      <strong>Details</strong>
      <br />
      <strong>Consultation</strong>
      <v-data-table
          :headers="consultancy_header"
          :items="consultancy_desserts"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          :hide-default-footer="true"
          disable-pagination
      >
        <template v-slot:item.slno="{ item }">
          {{ consultancy_desserts.indexOf(item) + 1 }}
        </template>
        <template slot="body.append">
          <tr>
            <td></td>
            <td></td>
            <th>Total Received Amount:</th>
              <td></td>
              <td></td>
            <th v-if="desserts">
              {{ desserts.consultation_ledger_total }}
            </th>
            <th v-if="desserts"></th>

          </tr>
        </template>
      </v-data-table>
      <br />
      <strong>Invetigation</strong>
      <v-data-table
          :headers="investigation_header"
          :items="investigation_desserts"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          :hide-default-footer="true"
          disable-pagination
      >
        <template v-slot:item.slno="{ item }">
          {{ investigation_desserts.indexOf(item) + 1 }}
        </template>
        <template slot="body.append">
          <tr>
            <td></td>
            <td></td>
              <th>Total Received Amount:</th>
              <td></td>
              <td></td>
            <th v-if="desserts">
              {{ desserts.investigation_ledger_total }}
            </th>
            <th v-if="desserts"></th>
          </tr>
        </template>
      </v-data-table>
      <br />
      <strong>Laser</strong>
      <v-data-table
          :headers="laser_header"
          :items="laser_desserts"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          :hide-default-footer="true"
          disable-pagination
      >
        <template v-slot:item.slno="{ item }">
          {{ laser_desserts.indexOf(item) + 1 }}
        </template>
        <template slot="body.append">
          <tr>

            <th></th>
            <th></th>
              <th>Total Received Amount:</th>
              <td></td>
              <td></td>
            <th v-if="desserts">
              {{ desserts.laser_ledger_total }}
            </th>
            <th v-if="desserts"></th>

          </tr>
        </template>
      </v-data-table>
        <br />
      <strong>Injection</strong>
      <v-data-table
          :headers="injection_header"
          :items="injection_desserts"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          :hide-default-footer="true"
          disable-pagination
      >
        <template v-slot:item.slno="{ item }">
          {{ injection_desserts.indexOf(item) + 1 }}
        </template>
        <template slot="body.append">
          <tr>

            <th></th>
            <th></th>
              <th>Total Received Amount:</th>
              <td></td>
              <td></td>
            <th v-if="desserts">
              {{ desserts.injection_ledger_total }}
            </th>
            <th v-if="desserts"></th>

          </tr>
        </template>
      </v-data-table>
        <br />
      <strong>Operation</strong>
      <v-data-table
          :headers="operation_header"
          :items="operation_desserts"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          :hide-default-footer="true"
          disable-pagination
      >
        <template v-slot:item.slno="{ item }">
          {{ operation_desserts.indexOf(item) + 1 }}
        </template>
        <template slot="body.append">
          <tr>

            <th></th>
            <th></th>
              <th>Total Received Amount:</th>
              <td></td>
              <td></td>
            <th v-if="desserts">
              {{ desserts.operation_ledger_total }}
            </th>
            <th v-if="desserts"></th>

          </tr>
        </template>
      </v-data-table>
      <br />
        <strong>Due Collection</strong>
      <v-data-table
          :headers="due_header"
          :items="due_desserts"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          :hide-default-footer="true"
          disable-pagination
      >
        <template v-slot:item.slno="{ item }">
          {{ due_desserts.indexOf(item) + 1 }}
        </template>
        <template slot="body.append">
          <tr>

            <th></th>
            <th></th>
              <th>Total Received Amount:</th>
              <td></td>
              <td></td>
            <th v-if="desserts">
              {{ desserts.duecollect_ledger_total }}
            </th>
            <th v-if="desserts"></th>

          </tr>
        </template>
      </v-data-table>
      <br />
      <strong>Void/Cancel</strong>
      <v-data-table
          :headers="void_header"
          :items="void_desserts"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          :hide-default-footer="true"
          disable-pagination
      >
        <template v-slot:item.slno="{ item }">
          {{ void_desserts.indexOf(item) + 1 }}
        </template>
        <template slot="body.append">
          <tr>

            <th></th>
            <th></th>
              <th>Total Received Amount:</th>
              <td></td>
              <td></td>
            <th v-if="desserts">
              {{ desserts.void_inv_ledger_total }}
            </th>
            <th v-if="desserts"></th>

          </tr>
        </template>
      </v-data-table>
      <br />
      <strong>Refund To Patient</strong>
      <v-data-table
          :headers="refund_header"
          :items="refund_desserts"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          :hide-default-footer="true"
          disable-pagination
      >
        <template v-slot:item.slno="{ item }">
          {{ refund_desserts.indexOf(item) + 1 }}
        </template>
        <template slot="body.append">
          <tr>

            <th></th>
            <th></th>
              <th>Total Received Amount:</th>
              <td></td>
              <td></td>
            <th v-if="desserts">
              {{ desserts.refund_inv_ledger_total }}
            </th>
            <th v-if="desserts"></th>

          </tr>
        </template>
      </v-data-table>
      <br />
      <strong>Paid to Doctor</strong>
      <v-data-table
          :headers="doctor_paid_header"
          :items="doctor_paid_desserts"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          :hide-default-footer="true"
          disable-pagination
      >
        <template v-slot:item.slno="{ item }">
          {{ doctor_paid_desserts.indexOf(item) + 1 }}
        </template>
        <template slot="body.append">
          <tr>

            <th></th>
            <th></th>
              <th>Total Received Amount:</th>
              <td></td>
            <th v-if="desserts">
              {{ desserts.doctor_pay_ledger_total }}
            </th>
            <th v-if="desserts"></th>

          </tr>
        </template>
      </v-data-table>
      <br />
    </v-card>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
.report-meta {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}

/* Responsive: allow horizontal scroll for wide tables */
::v-deep .v-data-table__wrapper {
  overflow-x: auto;
}
::v-deep .v-data-table__wrapper table {
  min-width: 900px;
}
</style>
<script>
import atshq from "../../../js/setup";
import moment from "moment";
export default {
  data() {
    return {
      search: "",
      errors: null,
      success: null,
      // errors: [],
      doctor_id: 0,
      isLoading: true,
      users: [],
      searchParam: {
        user: null,
        user_id: null,
      },
      date: moment().format('YYYY-MM-DD'),

      nowDate: moment().format('YYYY-MM-DD'),
      menu2: false,
      loadingstatus: false,
      login_user_id: localStorage.getItem("userId"),
      desserts: [],
      consultancy_desserts: [],
      consultancy_header: [
        { text: "SL", value: "slno" },
        { text: "Invoice ID", value: "invoice_id" },
        { text: "Patient ID", value: "patient_id" },
        { text: "Bill", value: "sub_total" },
        { text: "Discount", value: "discount_amount" },
        { text: "Received", value: "paid_amount" },
        { text: "Due", value: "due_amount" },
        { text: "Doctor", value: "doctor_payable" },
        { text: "Hospital", value: "hospital_payable" },
        { text: "Method", value: "payment_method" },

      ],

      investigation_desserts: [],
      investigation_header: [
          { text: "SL", value: "slno" },
          { text: "Invoice ID", value: "invoice_id" },
          { text: "Patient ID", value: "patient_id" },
          { text: "Bill", value: "total_amount" },
          { text: "Discount", value: "discount_amount" },
          { text: "Received", value: "paid_amount" },
          { text: "Due", value: "due_amount" },
          { text: "Doctor", value: "doctor_payable" },
          { text: "Hospital", value: "hospital_payable" },
          { text: "Method", value: "payment_method" },

      ],


      consultancy_ledger:{},

      operation_desserts: [],
      operation_header: [
          { text: "SL", value: "slno" },
          { text: "Invoice ID", value: "invoice_id" },
          { text: "Patient ID", value: "patient_id" },
          { text: "Bill", value: "total_amount" },
          { text: "Discount", value: "discount_amount" },
          { text: "Received", value: "paid_amount" },
          { text: "Due", value: "due_amount" },
          { text: "Doctor", value: "doctor_payable" },
          { text: "Hospital", value: "hospital_payable" },
          { text: "Method", value: "payment_method" },
      ],
        injection_desserts: [],
        injection_header: [
          { text: "SL", value: "slno" },
          { text: "Invoice ID", value: "invoice_id" },
          { text: "Patient ID", value: "patient_id" },
          { text: "Bill", value: "total_amount" },
          { text: "Discount", value: "discount_amount" },
          { text: "Received", value: "paid_amount" },
          { text: "Due", value: "due_amount" },
          { text: "Doctor", value: "doctor_payable" },
          { text: "Hospital", value: "hospital_payable" },
          { text: "Method", value: "payment_method" },
      ],
        laser_desserts: [],
        laser_header: [
          { text: "SL", value: "slno" },
          { text: "Invoice ID", value: "invoice_id" },
          { text: "Patient ID", value: "patient_id" },
          { text: "Bill", value: "total_amount" },
          { text: "Discount", value: "discount_amount" },
          { text: "Received", value: "paid_amount" },
          { text: "Due", value: "due_amount" },
          { text: "Doctor", value: "doctor_payable" },
          { text: "Hospital", value: "hospital_payable" },
          { text: "Method", value: "payment_method" },
      ],
        due_desserts: [],
        due_header: [
          { text: "SL", value: "slno" },
          { text: "Invoice ID", value: "invoice_id" },
          { text: "Patient ID", value: "patient_id" },
          { text: "Bill", value: "total_amount" },
          { text: "Discount", value: "discount_amount" },
          { text: "Received", value: "paid_amount" },
          { text: "Due", value: "due_amount" },
          { text: "Doctor", value: "doctor_payable" },
          { text: "Hospital", value: "hospital_payable" },
          { text: "Invoice Old", value: "remarks" },
          { text: "Method", value: "payment_method" },
      ],
      void_desserts: [],

      void_header: [
          { text: "SL", value: "slno" },
          { text: "Invoice ID", value: "invoice_id" },
          { text: "Patient ID", value: "patient_id" },
          { text: "Bill", value: "total_amount" },
          { text: "Discount", value: "discount_amount" },
          { text: "Received", value: "paid_amount" },
          { text: "Due", value: "due_amount" },
          { text: "Doctor", value: "doctor_payable" },
          { text: "Hospital", value: "hospital_payable" },
          { text: "Method", value: "payment_method" },
      ],
      refund_desserts: [],

      refund_header: [
          { text: "SL", value: "slno" },
          { text: "Invoice ID", value: "invoice_id" },
          { text: "Patient ID", value: "patient_id" },
          { text: "Patient Name", value: "patient.patient_name" },
          { text: "Invoice Refund Type", value: "refund_type" },
          { text: "Refund", value: "refund_amount" },
      ],
      doctor_paid_desserts: [],

      doctor_paid_header: [
          { text: "SL", value: "slno" },
          { text: "Doctor ID", value: "dr_id" },
          { text: "Doctor Name", value: "doctor.dr_name" },
          { text: "Note", value: "patient.patient_name" },
          { text: "Paid Amount", value: "payment_amount" },
          { text: "Paid by", value: "user.full_name" },
      ],
      received_payment_method_desserts: [],

      received_payment_method_header: [
          { text: "SL", value: "slno" },
          { text: "Method", value: "payment_method" },
          { text: "Amount", value: "invoice_amount" },
      ],

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Invoice report",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
      returnApiBaseURL: atshq.defaults.headers.common.api_base_URL,
    };
  },

  created() {
    this.getReports(this.date);
    this.getUsers();
  },
  computed: {
    selectedUserName() {
      if (!this.searchParam.user_id) return "All Users";
      const u = (this.users || []).find((x) => String(x.id) === String(this.searchParam.user_id));
      return (u && u.full_name) ? u.full_name : "Selected User";
    },
    printedByName() {
      const u = (this.users || []).find((x) => String(x.id) === String(this.login_user_id));
      if (u && u.full_name) return u.full_name;
      return this.login_user_id ? `User ID ${this.login_user_id}` : "N/A";
    },
  },
  methods: {
    getUsers() {
      atshq
          .get("users/user")
          .then((response) => {
            this.users = response.data.data;
            this.loadingstatus = false;
            this.isLoading = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    getReports() {

      if (!this.date) {
        this.errors = "Please select date";
        return false;
      }

      this.loadingstatus = true;
      atshq
          .get("reports/invoice-report?date=" +
              this.date +
              "&user_id=" + this.searchParam.user_id +
              "&login_user_id=" + this.login_user_id)
          .then((response) => {
            this.desserts = response.data.data;
            this.consultancy_desserts = response.data.data.invoice_consultation;
            this.consultancy_ledger = response.data.data.consultancy_ledger;
            this.investigation_desserts= response.data.data.invoice_investigation;
            this.operation_desserts = response.data.data.invoice_operation;
            this.laser_desserts = response.data.data.invoice_laser;
            this.injection_desserts = response.data.data.invoice_injection;
            this.due_desserts = response.data.data.invoice_duecollect;

            this.void_desserts = response.data.data.invoice_void;
            this.refund_desserts = response.data.data.invoice_refund;
            this.doctor_paid_desserts = response.data.data.paid_to_doctor;

            this.received_payment_method_desserts = response.data.data.invoice_method;
            this.loadingstatus = false;
            this.errors = null;
          })
          .catch((e) => {
            if (e.response.data.message) {
              this.errors = e.response.data.message;
            } else {
              this.errors = e;
            }
          });
    },

    toggleOrder() {
      this.sortDesc = !this.sortDesc;
    },
    nextSort() {
      let index = this.headers.findIndex((h) => h.value === this.sortBy);
      index = (index + 1) % this.headers.length;
      this.sortBy = this.headers[index].value;
    },
    getColor(status) {
      if (status == "open") return "orange";
      else return "green";
    },
    editItem(item) {
      alert(item.patient_id);
    },

    dateSelect() {
      this.loadingstatus = true;
      this.getReports();
    },

    printList() {
        if (!this.date) {
            this.$noty.error('Sorry! Please Select Date range');
            return
        }
        window.open(this.returnApiBaseURL + "print/invoice-report-print?date=" + this.date +
        "&user_id=" + this.searchParam.user_id +
        "&login_user_id=" + this.login_user_id);
    },
  },
};
</script>
